<dh-top-bar [background]="background$ | async" [image]="image$ | async"
            [isAdmin]="isAdmin$ | async" [isGuideOrAdmin]="isGuideOrAdmin$ | async"
            [isGuide]="isGuide$ | async" [isStudent]="isStudent$ | async"
            [isViewSkillsStackAccess]="isViewSkillsStackAccess$ | async"
            (logout)="onLogout()" (openProfileSettings)="onOpenProfileSettings()"
>
  <notification-popup *ngIf="isAdmin$ | async"></notification-popup>
</dh-top-bar>
